"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCY = function FlagCY(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.54,95.82C6.45,92.9,9.84,92,15.1,91s10.8-2.58,13.71-3.37S19,91.5,15.69,92.42s-13.15,3.4-13.15,3.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.69,87.6c-1.05-6.6,1.56-13.55,7.54-16.33,1.41,4.8-2.88,12.93-7.54,16.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.9,84.18c-3.2-5.52,2.19-12.61,6.2-16.06,1.86,3.31-1.4,13.2-6.2,16.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.3,79.92c-3.39-4.72.65-13,5-16.22,1.66,4.66,0,13-5,16.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.74,74c-3.13-4.44-.94-11.34,3.55-15.84,3.21,3.72.46,11.75-3.55,15.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.31,68.07c-2.61-4.21.59-14.26,4.8-17,1.8,3.72.45,14.23-4.8,17Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M66.32,66.48c-.76-6,9.75-12.67,14-12.48-.45,4.9-4.95,10.29-14,12.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.44,73.26c5-5.06,14.52-5.06,17.92-4-.89,3-12.2,9.41-17.92,4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M53.65,78.36c7-1.86,11.46-3.37,15.6.94-2.93,3.72-14.2,2.61-15.6-.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.74,82.86c6.65-3.56,14.71,1.69,15.92,4.74-7.41,3.1-16.06-4-15.92-4.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.63,88c6.06-2.32,13,.75,15.76,4.15C47.16,93.66,38.7,95.36,34.63,88Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.33,90.56c7-.78,13.61,4.5,15.06,7.49-8.84.86-12.26-1.8-15.06-7.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.1,95.82C20.24,92.9,16.85,92,11.59,91S.79,88.41-2.17,87.62,7.74,91.5,11,92.42s13.1,3.4,13.1,3.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.94,87.6C4.05,81,1.43,74.05-4.6,71.27-5.95,76.07-1.66,84.2,2.94,87.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7.22,84.18c3.27-5.52-2.18-12.61-6.19-16.06-1.86,3.31,1.4,13.2,6.19,16.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-16.67,79.92c3.45-4.72-.6-13-4.9-16.22-1.7,4.66,0,13,4.9,16.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.07,74c3.09-4.44.94-11.34-3.54-15.84-3.2,3.72-.45,11.75,3.54,15.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-33.62,68.07c2.67-4.21-.59-14.26-4.79-17-1.86,3.72-.46,14.23,4.79,17Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-39.68,66.48c.81-6-9.7-12.67-14-12.48.45,4.9,4.87,10.29,14,12.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-33.75,73.26c-5-5.06-14.52-5.06-17.92-4,.94,3,12.21,9.41,17.92,4Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27,78.36c-6.94-1.86-11.44-3.37-15.59.94,2.88,3.72,14.2,2.61,15.59-.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.1,82.86C-23.73,79.3-31.76,84.55-33,87.6c7.41,3.1,16-4,15.87-4.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8,88c-6-2.32-13,.75-15.71,4.15C-20.47,93.66-12,95.36-8,88Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.39,90.56c-7-.78-13.66,4.5-15.09,7.49,8.89.86,12.28-1.8,15.09-7.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-74.63-9.27s-1.93,2.52,1.35,8.89.92,13.74,4.46,16.09.14,7,4.19,10.13S-50,36.11-42.62,37s14.47-6.58,18.7-1.11,3.31,9.33,7.3,9.75,4-1.34,3.71-4,2.64-10,9.41-10,13.94-.8,25.36-5.11,17-6.37,18.48-13.14S46-1.41,54.06,2.29s7.51,2,10,.19,10.79,3.37,12.67.65S62-13,63-20.15s3.17-13,10-13.58S78-42,85.07-45.79,95.39-50,101-55.72s20.26-17.14,20.26-17.14S92.67-59.18,87-57.93,78.89-48.44,63-44,46.23-37.84,34.16-35.2C23.3-32.81-1.25-33.61-15.76-38.27a2.92,2.92,0,0,0-3.82,3c.6,7.06.43,19.75-8.14,21.72,0,0-11.68-8.73-19-4.9S-59.34-.95-64.82-3.07-71-13.94-74.63-9.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc850"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCY;
exports["default"] = _default;